import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
// todo: remove when we move tokens to a seperate lib to preserve lazyloading
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  PREVIEW_DATA_TYPE,
  QuotaConfig,
  SenderTypeFromBusinessId,
  stepDataForBusinessEmail,
} from '@galaxy/campaign/dependencies';
import { map, shareReplay } from 'rxjs/operators';
import { AccountGroupService } from '../account-group';
import { AuthService } from '../auth.service';
import { Environment, EnvironmentService } from '@galaxy/core';
import { CONFIG_TYPE } from '@galaxy/campaign/shared';
import { combineLatest, of } from 'rxjs';
import { PartnerMarketConfigService } from '../partner-market-config';
import { CampaignConfigurationService } from './campaign-configuration.service';

export const CampaignConfigFactory = () => {
  const campaignsProdAppID = 'MP-ZGJ6V4QRP77WPMDKXS6VDRNX58Q42P7P';
  const campaignsDemoAppID = 'MP-WF5KS7FHTGV4LR5DBQ4D6XKCCDB5B6G7';
  const ag = inject(AccountGroupService) as AccountGroupService;
  const authService = inject(AuthService);
  const environment = inject(EnvironmentService);
  const partnerMarketConfigService = inject(PartnerMarketConfigService);
  const campaignConfigurationService = inject(CampaignConfigurationService);

  const cfg: CONFIG_TYPE = {
    sender$: SenderTypeFromBusinessId(ag.currentAccountGroupId$),
    userId$: toObservable(authService.userId),
    basePath$: ag.currentAccountGroupId$.pipe(map((v) => `account/location/${v}/campaigns`)),
    location$: ag.currentAccountGroup$.pipe(map((v) => v.country)),
    productBasePath$: combineLatest([ag.currentAccountGroupId$, partnerMarketConfigService.businessAppConfig$]).pipe(
      map(([accountGroupID, businessAppConfig]) => {
        if (!businessAppConfig.showStore) {
          return null;
        }
        if (environment.getEnvironment() == Environment.DEMO) {
          return `account/location/${accountGroupID}/store/app/${campaignsDemoAppID}`;
        } else if (environment.getEnvironment() == Environment.PROD) {
          return `account/location/${accountGroupID}/store/app/${campaignsProdAppID}`;
        }
      }),
    ),
    smsSettingsPath$: ag.currentAccountGroupId$.pipe(
      map((accountGroupID) => {
        return `/account/location/${accountGroupID}/settings/sms-configuration`;
      }),
    ),
    campaignsConfigurationService$: of(campaignConfigurationService).pipe(shareReplay(1)),
  };
  return cfg;
};

export const CampaignPreviewDataFactory = () => {
  const ag = inject(AccountGroupService) as AccountGroupService;
  const cfg: PREVIEW_DATA_TYPE = ag.currentAccountGroupId$.pipe(map((agid) => stepDataForBusinessEmail(agid)));
  return cfg;
};

export const CampaignQuotaConfigFactory = () => {
  const ag = inject(AccountGroupService) as AccountGroupService;
  const cfg: QuotaConfig = {
    sender$: SenderTypeFromBusinessId(ag.currentAccountGroupId$),
  };
  return cfg;
};
